import * as React from "react";
import { RadioButtonGroup } from "@grandvisionhq/common";
/* empty css                                                                                         */
const ShippingMethodsList = ({
  handleChange,
  hasValidationError,
  selectedShippingMethod,
  shippingMethodItems
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "shipping-methods-list-container" }, /* @__PURE__ */ React.createElement(
    RadioButtonGroup,
    {
      scope: "shippingMethod",
      items: shippingMethodItems,
      value: selectedShippingMethod,
      onChange: handleChange,
      hasError: hasValidationError
    }
  ));
};
export {
  ShippingMethodsList
};
//# sourceMappingURL=ShippingMethodsList.js.map
